const resetPassword = {
  title: "Endurstilla lykilorð",
  subtitle: "Sláðu inn nýtt lykilorð hér fyrir neðan.",
  form: {
    newPasswordLabel: "Nýtt lykilorð",
    newPasswordPlaceholder: "Sláðu inn nýtt lykilorð",
    strengthLabel: "Styrkur lykilorðs:",
    confirmPasswordLabel: "Staðfesta lykilorð",
    confirmPasswordPlaceholder: "Staðfestu nýja lykilorðið",
    requirementsTitle: "Kröfur um lykilorð:",
  },
  loading: "Hleð...",
  resetting: "Endurstilli...",
  submit: "Endurstilla lykilorð",
  backToLogin: "Til baka í innskráningu",
  errors: {
    passwordMismatch: "Lykilorðin stemma ekki",
    resetFailed: "Ekki tókst að endurstilla lykilorð",
  },
};

export default resetPassword;
